export default function Count({count = 0}) {
    const paddedCount = count.toString().padStart(4, '0');
    return (
        <div className="count">
            {paddedCount.toString().split('').map((num, i) => <span key={i}>{num}</span>)}
        </div>
    )
}